export default __webpack_public_path__ + "static/media/close_icon.acfc4175.svg";